export const APPEARANCE = {
    Neutral: 'neutral',
    Primary: 'primary',
    Error: 'error',
    Warning: 'warning',
    Success: 'success',
    Info: 'info',
};
export const SIZE = {
    S: 's',
    M: 'm',
};
export const APPEARANCE_TO_COLOR_MAP = {
    [APPEARANCE.Neutral]: 'neutral',
    [APPEARANCE.Primary]: 'primary',
    [APPEARANCE.Error]: 'red',
    [APPEARANCE.Warning]: 'yellow',
    [APPEARANCE.Success]: 'green',
    [APPEARANCE.Info]: 'blue',
};
export const APPEARANCE_TO_LINK_COLOR_MAP = {
    [APPEARANCE.Neutral]: 'primary',
    [APPEARANCE.Primary]: 'primary',
    [APPEARANCE.Error]: 'red',
    [APPEARANCE.Warning]: 'yellow',
    [APPEARANCE.Success]: 'green',
    [APPEARANCE.Info]: 'blue',
};
